import {Link} from 'react-router-dom';
import {useLang} from '../../hooks/useLang';
import {buildPath} from '../../services/language';

const AppCard = ({app}) => {
  const {lang, t} = useLang();

  return (
    <Link className={`app-card app-card--${app.id}`} to={buildPath(lang, app.page)} onClick={() => window.scrollTo(0, 0)}>
      <img
        className="app-card__icon"
        src={app.icon.src}
        srcSet={`${app.icon.src2x} 2x`}
        width="64"
        height="64"
        alt=""
      />
      <div className="app-card__body">
        <h2 className="app-card__name">{t(`apps.${app.id}.name`)}</h2>
        <p className="app-card__meta">
          {t(`apps.${app.id}.downloads`)}
          <span className="app-card__dot" aria-hidden="true"/>
          <span aria-label={`${t('common.rating')} ${app.rating}`}>★ {app.rating}</span>
        </p>
        <p className="app-card__descr">{t(`apps.${app.id}.description`)}</p>
      </div>
    </Link>
  );
};

export default AppCard;
